'use strict';

import notificationAPI from './notification';
import utils from './utils';

export default function webpushRegistration(workerFile, cbSuccess, cbError) {
    var serviceWorkerRegistration = null;
    var serviceWorkerController = navigator.serviceWorker.controller;
    
    var onRegister = new Promise(function (resolve, reject) {
        if (!notificationAPI.isSupported()) {
            utils.rejectWithReason(reject, 'not_supported', 'Notifications are not supported')();
            return;
        }

        function resolveServiceWorker() {
            // webPushSubscription = new subscriptionService(serviceWorkerRegistration.pushManager, webPushConfig);

            serviceWorkerController = serviceWorkerRegistration.active;
            if (serviceWorkerRegistration.installing) {
                serviceWorkerRegistration.installing.onstatechange = function (e) {
                    if (e.currentTarget.state == 'activated') {
                        serviceWorkerController = serviceWorkerRegistration.active;
                        resolve({
                            registration: serviceWorkerRegistration,
                            pushManager: serviceWorkerRegistration.pushManager,
                            controller: serviceWorkerController
                        });
                    }
                };
            } else {
                resolve({
                    registration: serviceWorkerRegistration,
                    pushManager: serviceWorkerRegistration.pushManager,
                    controller: serviceWorkerController
                });
            }
        }

        if (!serviceWorkerRegistration) {
            navigator.serviceWorker.register(workerFile).then(function (swSubscription) {
                serviceWorkerRegistration = swSubscription;
                resolveServiceWorker();
            }).catch(utils.rejectWithReason(reject, 'sw_registration', 'Unable to register Service Worker'));
        } else {
            resolveServiceWorker();
        }
    });

    utils.applyPromiseCallbacks(onRegister, cbSuccess, cbError);

    return onRegister;
}


//////////////////
// WEBPACK FOOTER
// ./src/services/registration.js
// module id = 18
// module chunks = 0